export enum SubmissionScopeType {
  WorkspaceItem = 'submission',
  WorkflowItem = 'workflow',
  EditItem = 'edit'
}
